import { BaseMetaColumn } from "namirasoft-core";
import { TableColumnInfo, TableRowInfo } from "../components/NSTable";

export abstract class BaseColumnFormatter
{
    public width: string = "100px";
    public onclick_overrided: boolean = false;
    abstract format(value: any, column: TableColumnInfo, row: TableRowInfo<any>, printable: boolean): any;
    static getColumn(column: BaseMetaColumn, formatter: BaseColumnFormatter): TableColumnInfo
    {
        return {
            index: 0,
            ...column,
            formatter
        };
    }
}